export const selectIdFromLocation = (location) => location.split('/').pop();
